import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800 relative overflow-hidden w-full min-h-screen bg-center bg-cover bg-no-repeat"
      style={{
        backgroundImage:
          "url('/images/bg1.jpg')",
      }}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium mb-8">
          <Sparkles className="w-4 h-4" />
          <span>Let's Build Something Extraordinary</span>
        </div>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          Ready to Transform Your Business?
        </h2>
        <p className="text-xl text-indigo-100 mb-12 max-w-3xl mx-auto">
          Partner with TECHSPR to accelerate your digital transformation journey. Our experts are ready to help you achieve measurable business results.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            asChild
            size="lg"
            className="bg-white text-indigo-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-xl shadow-xl hover:shadow-2xl transition-all duration-200 group"
          >
            <Link to="/contact" className="flex items-center space-x-2">
              <span>Get Started</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
            </Link>
          </Button>
          <Button
            asChild
            size="lg"
            variant="outline"
            className="border-2 border-white text-white hover:bg-white/10 px-8 py-6 text-lg rounded-xl transition-all duration-200"
          >
            <Link to="/client-success">View Success Stories</Link>
          </Button>
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div>
            <div className="text-4xl font-bold text-white mb-2">50+</div>
            <div className="text-indigo-200">Global Clients</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-white mb-2">98%</div>
            <div className="text-indigo-200">Client Satisfaction</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-white mb-2">100+</div>
            <div className="text-indigo-200">Projects Delivered</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-white mb-2">4.2+</div>
            <div className="text-indigo-200">Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;